import React, { useState } from 'react';
import axios from 'axios';
import moment from 'moment';
import { Button } from 'react-bootstrap';
import { Icon } from '../../../common/components/Utilities';
import RestrictedContent from '../../../common/components/RestrictedContent';
import DataSelect from '../../../common/components/DataSelect';

function LocationTimesheetCsv({ groups, csrfToken }) {
  const [loading, setLoading] = useState(false);
  const [locationName, setLocationName] = useState('');

  const getCsv = async () => {
    setLoading(true);

    try {
      await axios.get(`/report/location-timesheet-csv?location_name=${locationName}`, {}, {
        headers: {
          'X-CSRF-Token': csrfToken,
        },
        responseType: 'blob',
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `timesheet-${locationName}-${moment().format('DD-MM-YYYY')}.csv`);
        document.body.appendChild(link);
        link.click();
      });
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <RestrictedContent group={groups.OPERATIONS}>
      <div className="mb-2">
        <DataSelect url="/resource/locations" value={locationName} onValueChange={setLocationName} titleKey="name" valueKey="name" noneTitle=" " />
      </div>
      <Button variant="outline-primary" block disabled={loading || !locationName} onClick={getCsv} className="mb-2 text-left">
        <Icon icon="file-csv" variant="fad" append="mr-2" />
        {locationName ? `Download Timesheet CSV for ${locationName}` : 'Download Location Timesheets'}
      </Button>
    </RestrictedContent>
  );
}

export default LocationTimesheetCsv;
